/* global moment*/
angular
  .module('userLeaveReasons')
  .component('userLeaveReasons', {
    template: require('./user-leave-reasons.template.html'),
    controller: ['$rootScope', '$scope', '$resource', '$route', '$location', '$window', '$translate', 'AuthService', 'envService',
      function UserLeaveReasonsController($rootScope, $scope, $resource, $route, $location, $window, $translate, AuthService, envService) {
        $scope.doLogout = $rootScope.gLogout;
        $scope.showUserView = $rootScope.gShowUserView;
        $rootScope.mainmenu = 'members';
        $rootScope.menu = 'leaveReasons';
        const APIURL = envService.read('apiUrl');
        if (!AuthService.isAuthenticated()) {
          $location.path('/login');
          return;
        }
        this.reasons = {};
        this.totalCount = 0;
        $resource(`${APIURL}/admin/reasons/user/leave`).get({}).$promise
          .then((data) => { this.reasons = data.reasons; this.totalCount = data.totalCount; return Promise.resolve(); })
          .catch((err) => {
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        this.paging = (page) => {
          $resource(`${APIURL}/admin/reasons/user/leave`).get({ PAGE: page - 1, QUERY: this.query }).$promise
            .then((data) => { this.reasons = data.reasons; this.totalCount = data.totalCount; return Promise.resolve(); })
            .catch((err) => {
              if (err.data && err.data.msg) {
                alert(err.data.msg);
              } else {
                alert($translate.instant('알수 없는 에러 입니다.'));
              }
            });
        };
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/user-leave-reasons/user-leave-reasons.component.js